const facebook = require('../assets/icons/facebook.png')
const google = require('../assets/icons/google.png')

export { facebook, google}